import { useMemo } from "react";
import { optimistActions, useOptimistReportDispatch, useOptimistReportSelector, } from "./state";
export default function useTrackSelector() {
    const selectedTrack = useOptimistReportSelector(state => state.selectedTrackId);
    const dispatch = useOptimistReportDispatch();
    return useMemo(() => {
        return [
            selectedTrack,
            (trackId) => dispatch(optimistActions.setSelectedTrackId(trackId)),
        ];
    }, [selectedTrack, dispatch]);
}
